import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

interface SubmitFaxFormQuestionaireProps {
  form_id: string;
  order_id: string;
}

export const submitFaxFormQuestionaire = async (
  props: SubmitFaxFormQuestionaireProps,
) => {
  const token = await getBearerToken();

  const body: SubmitFaxFormQuestionaireProps = {
    form_id: props.form_id,
    order_id: props.order_id,
  };

  const response = await fetch(API_ENDPOINTS.SUBMIT_FAX_FORM_QUESTIONNAIRE, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
    );
  }

  return response.json();
};
